import React from 'react';

const LabelTag = ({ label, quickAddLabel }) => {
  const addLabel = () => {
    quickAddLabel({ value: label.value, img: label.imgUrl });
  };
  return (
    <div className="label-tag" onClick={addLabel}>
      <img src={label.imgUrl} alt="Label Icon" />
      <span>{label.value}</span>
    </div>
  );
};

export default LabelTag;
